module.exports = __webpack_public_path__ + "fonts/summernote.f694db69.woff2";